let navigateFunction = null;
let refreshFunction = null;

const setNavigate = (navigate) => {
  navigateFunction = navigate;
};

const setRefreshFunction = (refresh) => {
  refreshFunction = refresh;
};

/**
 * Navigate to a specific path with optional parameters
 * @param {*} path
 * @param {*} params
 */
const navigateTo = (path) => {
  if (navigateFunction) {
    navigateFunction(path);
  } else {
    //
  }
};

//force le rechargement de la page
const reloadPage = () => {
  if (navigateFunction) {
    navigateFunction(0);
  } else {
    //
  }
};

const forceReloadPage = () => {
  window.location.reload();
};

const refreshPage = () => {
  if (refreshFunction) {
    refreshFunction();
  } else {
    //
  }
};

const navigateToWithParams = (path, params) => {
  if (navigateFunction) {
    navigateFunction(path, { state: params });
  } else {
    //
  }
};

const NavigationService = {
  navigateTo,
  setNavigate,
  reloadPage,
  navigateToWithParams,
  forceReloadPage,
  refreshPage,
  setRefreshFunction,
};

export {
  setNavigate,
  navigateTo,
  navigateToWithParams,
  reloadPage,
  forceReloadPage,
  refreshPage,
  setRefreshFunction,
};

export default NavigationService;
